import {
    createVehicleCategoryApi,
    deleteVehicleCategoryApi,
    getVehicleCategory,
    updateVehicleCategoryApi,
    getVehicleCategoryByIdApi
} from "../../helpers/backend_helper";

import {
    getVehicleTypeList,
    vehicleTypeById,
    errorMessages,
    setLoading
} from "./reducer";
export const getVehicleTypeCategory = (currentPage, pageSize, searchText) => async (dispatch) => {
    dispatch(setLoading({ type: "read", value: true }));
    try {
        let response;
        response = getVehicleCategory(currentPage, pageSize, searchText);
        const data = await response;
        dispatch(getVehicleTypeList(data));
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
    } finally {
        dispatch(setLoading({ type: "read", value: false }));
    }
};



export const getVehicleTypeCategoryById = (id) => async (dispatch) => {
    dispatch(setLoading({ type: "getById", value: true }));
    try {
        let response;
        response = getVehicleCategoryByIdApi(id);
        const data = await response;
        dispatch(vehicleTypeById(data));
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
    } finally {
        dispatch(setLoading({ type: "getById", value: false }));
    }
};



export const createVehicleCategory = (data) => async (dispatch) => {
    dispatch(setLoading({ type: "create", value: true }));
    try {
        await createVehicleCategoryApi(data);
        return { success: true, message: "Vehicle Category created successfully!" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "create", value: false }));
    }
};


export const updateVehicleCategory = (id, data) => async (dispatch) => {
    dispatch(setLoading({ type: "update", value: true }));
    try {
        await updateVehicleCategoryApi(id, data);
        return { success: true, message: "Vehicle Category updated successfully!" };
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "update", value: false }));
    }
};


export const deleteVehicleCategory = (id) => async (dispatch) => {
    dispatch(setLoading({ type: "delete", value: true }));
    try {
        await deleteVehicleCategoryApi(id);
        return { success: true, message: "Vehicle Category deleted successfully!" };
    } catch (error) {

        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "delete", value: false }));
    }
};  